// extracted by mini-css-extract-plugin
export default {"container":"Technologies_container__9OAd-","info":"Technologies_info__nsijB","cards":"Technologies_cards__JUznv"};